import './NewAd.sass';

import { FC } from 'react';
import {
  AnimatedEmoji,
  Header,
  List,
  ListItem,
  LottieIcon,
  Placeholder,
  ScrollView,
} from '$uikit';
import { useTranslator } from '$hooks';
import { IcProfile56, IcPost56, IcClip56 } from '$assets';
import { MetaTags } from '$shared/components';
import { NEW_AD_PROFILE, NEW_AD_POST, NEW_AD_CLIP } from '$shared/constants/modals';
import { hideModal } from '$navigation/helper';

export const NewAd: FC = () => {
  const t = useTranslator();

  return (
    <>
      <MetaTags title={t('new_ad_title')} />
      <Header showBackButton>{t('new_ad_title')}</Header>
      <ScrollView>
        <div className="NewAd">
          <Placeholder
            className="NewAd__head"
            title={t('new_ad_header')}
            icon={<AnimatedEmoji emoji="📣" size={80} />}
            iconSize={80}
          >
            {t('new_ad_header_text')}
          </Placeholder>

          <List>
            <ListItem
              leftIcon={<IcProfile56 />}
              chevron
              iconSize="large"
              modal={NEW_AD_PROFILE}
              description={t('new_ad_profile_description')}
            >
              {t('new_ad_profile_title')}
            </ListItem>
          </List>
          <List>
            <ListItem
              leftIcon={<IcPost56 />}
              chevron
              iconSize="large"
              modal={NEW_AD_POST}
              description={t('new_ad_post_description')}
            >
              {t('new_ad_post_title')}
            </ListItem>
          </List>
          {/*<List>*/}
          {/*  <ListItem*/}
          {/*    leftIcon={<IcClip56 />}*/}
          {/*    chevron*/}
          {/*    iconSize="large"*/}
          {/*    modal={NEW_AD_CLIP}*/}
          {/*    description={t('new_ad_clip_description')}*/}
          {/*  >*/}
          {/*    {t('new_ad_clip_title')}*/}
          {/*  </ListItem>*/}
          {/*</List>*/}
        </div>
      </ScrollView>
    </>
  );
};
